import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-loyalty-info-popover',
  templateUrl: 'loyalty-info-popover.html',
})
export class LoyaltyInfoPopoverPage {

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {

  }

  ionViewDidLoad() {

  }

  closePopover() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/loyalty-info-popover/loyalty-info-popover.ts